import cx from 'classnames';
import { CSSProperties } from 'react';

import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  color: 'black' | 'white' | 'gray';
  size: number;
  style?: CSSProperties;
  testId?: string;
}

const defaultProps = {
  color: 'black',
  size: 50,
};

function LoadingSpinner({ color, size, style, testId }: LoadingSpinnerProps) {
  const classNames = cx({
    LoadingSpinner: true,
    'LoadingSpinner--white': color === 'white',
    'LoadingSpinner--black': color === 'black',
    'LoadingSpinner--gray': color === 'gray',
  });

  return (
    <svg
      className={classNames}
      data-testid={testId}
      height={`${size}px`}
      style={style}
      viewBox="0 0 69 69"
      width={`${size}px`}
    >
      <line className="LoadingSpinner__part" x1="34.5" x2="34.5" y1="15.5" y2="3.5" />
      <line className="LoadingSpinner__part" x1="44" x2="50" y1="18" y2="7.7" />
      <line className="LoadingSpinner__part" x1="51" x2="61.3" y1="25" y2="19" />
      <line className="LoadingSpinner__part" x1="53.5" x2="65.5" y1="34.5" y2="34.5" />
      <line className="LoadingSpinner__part" x1="51" x2="61.3" y1="44" y2="50" />
      <line className="LoadingSpinner__part" x1="44" x2="50" y1="51" y2="61.3" />
      <line className="LoadingSpinner__part" x1="34.5" x2="34.5" y1="53.5" y2="65.5" />
      <line className="LoadingSpinner__part" x1="25" x2="19" y1="51" y2="61.3" />
      <line className="LoadingSpinner__part" x1="18" x2="7.7" y1="44" y2="50" />
      <line className="LoadingSpinner__part" x1="15.5" x2="3.5" y1="34.5" y2="34.5" />
      <line className="LoadingSpinner__part" x1="18" x2="7.7" y1="25" y2="19" />
      <line className="LoadingSpinner__part" x1="25" x2="19" y1="18" y2="7.7" />
    </svg>
  );
}

LoadingSpinner.defaultProps = defaultProps;

export default LoadingSpinner;
